var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_vm._v(" "),_c('ServeYou'),_vm._v(" "),_c('ServeSections'),_vm._v(" "),_c('Vlogs'),_vm._v(" "),_c('Blogs'),_vm._v(" "),(false)?_c('Ebooks'):_vm._e(),_vm._v(" "),_c('VlogPlayer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }